import { GoogleMapsOverlay } from '@deck.gl/google-maps';
import { Layer } from '@deck.gl/layers';
import { Observable } from 'rxjs';

import { OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { SnLayer, SnLayerSetting } from '@lib/api/entities';
import { GoogleMap, GoogleMapMarker } from '@lib/geo/google/map';

import { IFsMap } from '../types';

// Interfaces to replace dashboard imports
export interface IFeatureDetailsPopoutComponent {
  // Define the minimal interface needed for the popout component
  // This can be extended as needed
}

export interface IMarkerProperties {
  id: string;
  feature: any;
  lonLat: any;
  type: any;
  style: any;
  icon: any;
  iconLabel: any;
  label: any;
  title: string | null;
}

export abstract class FsMapLayersServiceProvider<
  TOverlay = GoogleMapsOverlay,
  TMarker = GoogleMapMarker,
  TMap extends IFsMap = GoogleMap,
> {
  abstract get layerSettings(): any | SnLayerSetting;
  abstract get zoomToExtent$(): Observable<SnLayer>;
  abstract get avlMarkers(): any[];
  abstract get busModemMarkers(): any[];
  abstract get skydioMarker(): any[];
  abstract get layerMarkers(): TMarker[];
  abstract get activePopouts(): MatDialogRef<IFeatureDetailsPopoutComponent>[];
  abstract get activePopoutCount(): number;
  abstract get enabledLayers(): Map<string, SnLayer>;

  abstract isAvailable: boolean;
  abstract registryCameras: any[];
  abstract defaultAvlLayer: SnLayer;
  abstract activeAvlLayer: SnLayer;
  abstract minimumZoomLayers: any[];
  abstract deckGLOverlay: TOverlay[];
  abstract deckGlLayers: Layer[];
  abstract markers: any;
  abstract followMarker: any;

  abstract onMapLoaded(map: TMap): void;
  abstract isEnabled(id: string): boolean;
  abstract isLoading(id: string): boolean;
  abstract toggle(layer: SnLayer): Observable<boolean>;
  abstract openPopout(layer: SnLayer, marker: any, fields: string[]): void;
  abstract addPolyline(start: any, end: any): void;
  abstract removePolylines(): void;
  abstract zoomToExtent(layer: SnLayer): void;
  abstract openAxonOfficerListDialog(layer: SnLayer): void;
  abstract followOfficerMarker(layer: SnLayer, markerProperties: IMarkerProperties): void;
  abstract colorCheck(layer: SnLayer): boolean;
  abstract getColor(layer: SnLayer, num: string): string;
  abstract trackMarkerClick(markerData: any, layer?: SnLayer): void;
}
